import React, { useState, useContext, useEffect } from "react";
import StepperNavigationButtons from "../../StepperNavigationButtons/StepperNavigationButtons";
import FormBuilder from "../FormBuilder/FormBuilder";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import { EWContext } from "../../../context/EWContext";
import { getFormAnswers } from "../../../utils/utils";

function HomeDetailsQuestionsForm(props) {
    const { group, handleNext, handleBack } = props;
    const [loading, setLoading] = useState(false);
    const [errorFields, setErrorFields] = useState(true);
    const [accountState, setAccountState] = useContext(EWContext);
    const {
        customErrors,
        questions: {
          homeDetails: questions
        },
        answers: {
          homeDetails: homeDetailsAnswers
        },
        productInfo,
        conditionSpecificBehaviors
    } = accountState;
    const [homeDetailsFormAnswers, setHomeDetailsAnswers] = useState(homeDetailsAnswers);
    const [errorInForm, setErrorInForm] = useState({
        message: customErrors.genericError,
        genericMessage: customErrors.contactError,
        labelButton: "Back",
        error: false
    });

    useEffect(() => {
        if (errorInForm.error) {
            setAccountState((prevAccountState) => ({
                ...prevAccountState,
                ...{
                    submitAttempts: prevAccountState.submitAttempts + 1,
                    eligibilityError: errorInForm,
                },
            }));
        }
    }, [errorInForm, setAccountState]);

    useEffect(() => {
        if (homeDetailsAnswers.length > 0) {
            const formIsAnswered = homeDetailsAnswers.every((field) => {
                if(field.type === "date") {
                    if(field.value == "Invalid Date") {
                      return false
                    }
                    let dateRange =  questions.find(ques => ques.id === field.id).field.rangeDates;

                    if(dateRange?.minDate?.date) {

                        if(new Date(field.value ) < new Date(dateRange.minDate.date)){
                            return false
                        }
                    } 

                    if(dateRange?.maxDate?.date) {
                        
                        if(new Date(field.value) > new Date(dateRange.maxDate.date)) {
                            return false
                        }
                    }
                }
                return field ? (field.required ? field.value !== "" : true) : false
            });
            if (formIsAnswered) {
                setErrorFields(false);
            }
        }
    }, [homeDetailsAnswers]);

    const displayError = (errorMessage) => {
        setLoading(false);
        setErrorInForm( prev => {
            return {
                ...prev,
                ...{
                    message: errorMessage || customErrors.genericError,
                    error: true
                }
            }
        })
    };

    const handleOnFormAnswered = (answers) => {
        const formIsAnswered = getFormAnswers(answers, questions).every(
            (field) => {
                return field.required ? field.value !== "" : true;
            }
        );
        if (formIsAnswered) {
            setErrorFields(false);
            const homeDetailsAnswers = getFormAnswers(answers, questions);
            setHomeDetailsAnswers(homeDetailsAnswers);
        } else {
            setErrorFields(true);
        }
    };

    /**function for question check for showing the error message */
    function questioncheck(data){
       return homeDetailsFormAnswers.find(answer => answer.id === data) ? homeDetailsFormAnswers.find(answer => answer.id === data).value : ''
    }

    /**function for checking the questions dropdown value and showing the error message if not eligible for a particular question*/
    const homeDetailsQuestionCheck=()=>{
        if (questioncheck("homeType") === conditionSpecificBehaviors.cr_MultiFamily) {               
            displayError(conditionSpecificBehaviors.cr_multiFamilyError);
        }else if (questioncheck("homeFuelType") === conditionSpecificBehaviors.cr_homeFuelType) {               
            displayError(conditionSpecificBehaviors.cr_homeFuelTypeError);
        }else if (questioncheck("homeBuild") === conditionSpecificBehaviors.cr_homeBuild) {               
            displayError(conditionSpecificBehaviors.cr_homeBuildError);
        }else  if (questioncheck("homeMeter") === conditionSpecificBehaviors.cr_homeMeter) {               
            displayError(conditionSpecificBehaviors.cr_homeMeterError);
        }else if (questioncheck("DoYouOwnOrRent") === conditionSpecificBehaviors.cr_ownOrRentedVaue) {               
            displayError(conditionSpecificBehaviors.cr_ownOrRentedError);
        }else if (questioncheck("homeDominion") === conditionSpecificBehaviors.cr_homeDominion) {               
            displayError(conditionSpecificBehaviors.cr_homeDominionError);
        }else if (questioncheck("homePayment") === conditionSpecificBehaviors.cr_homePayment) {               
            displayError(conditionSpecificBehaviors.cr_homePaymentError);
        }else if (questioncheck("howmanyUnits") === conditionSpecificBehaviors.howmanyUnitsValue) {               
            displayError(conditionSpecificBehaviors.howmanyUnitsValueError);
        }else {
            setLoading(false);
            handleNext(true); 
        }
    }

    /**function for checking the questions dropdown value and showing the error message if not eligible for a particular question*/
    const homeUnitsQuestionCheck=()=>{
        if (conditionSpecificBehaviors?.cr_homeUnits?.homeTypes &&
                conditionSpecificBehaviors?.cr_homeUnits?.homeTypes.includes(questioncheck("homeType"))) { 
            if(questioncheck("howmanyUnits") === conditionSpecificBehaviors?.cr_homeUnits?.homeUnits) {
                displayError(conditionSpecificBehaviors?.cr_homeUnits?.notEligibilityError);
            } else {
                setLoading(false);
                handleNext(true); 
            }
        } else {
            setLoading(false);
            handleNext(true); 
        }
    }

    const handleSubmit = (evt) => {
        setLoading(true);
        evt.preventDefault();
        setAccountState((prevAccountState) => ({
            ...prevAccountState,
            answers: {
              ...prevAccountState.answers,
              homeDetails: [...homeDetailsFormAnswers]
            },
        }));
        if (productInfo.cr_fuel_type && productInfo.cr_fuel_type.length !== 0) {
            const fuelType = homeDetailsFormAnswers.find(answer => answer.id === "homeFuelType").textValue;
            if (fuelType === productInfo.cr_fuel_type) {
                setLoading(false);
                handleNext(true);
            } else {
                displayError(customErrors.fuelTypeError[productInfo.cr_fuel_type]);
            }
        } else if(conditionSpecificBehaviors?.cr_homeDeatilQuestions){
            homeDetailsQuestionCheck();
        } else if(conditionSpecificBehaviors?.cr_homeUnits){
            homeUnitsQuestionCheck();
        } else {
            setLoading(false);
            handleNext(true);
        }
    };

    return (
        <FormBuilder
            questions={questions}
            answers={homeDetailsAnswers}
            onFormAnswered={handleOnFormAnswered}
            handleSubmit={handleSubmit}
            formInstructions={group.instructions}
            requiredFieldsSubtitule={true}
        >
            <StepperNavigationButtons
                handleBack={handleBack}
                handleNext={() => null}
                loading={loading}
                nextButtonDisabled={errorFields}
            />
        </FormBuilder>
    );
}

export default withErrorHandler(HomeDetailsQuestionsForm);
